<template>
	<el-container style="height:100%;">
    <el-aside width="60px" style="min-height:100%;position:absolute;bottom:0;top:-1px;z-index:8;background-color:#204969;">
	  <div class="hw_left_top">
	     <el-popover
		  placement="bottom"
		  width="320"
		  v-model="productvisible"
		  trigger="hover">
		  <el-card class="box-card" shadow="never" style="border:none;max-height:400px;overflow-y:auto;">
			  <div slot="header" class="clearfix">
				<span style="font-size:16px;color:#22222;">我的产品</span>				
				<el-input placeholder="搜索关键字" style="float:right;width:170px;" size="small" v-model="product_keyword"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
			  </div>
			  <div v-for="o in productList" :key="o.id" :title="o.name" @click="selectProduct(o)" class="text item">
				<img style="width:20px;height:20px;vertical-align:middle;margin-right:10px;" :src="o.imageUrl" />{{o.name}}
			  </div>
			</el-card>
			<div class="nav-item" slot="reference"><i style="font-size:20px !important;" class="fa fa-archive"></i><div>应用</div></div>		  
		</el-popover>
		 
	  </div>
	  <div class="hw_left_bottom">
	     <el-tooltip class="item" effect="dark" content="添加查看广告组列表" placement="right">
			 <el-popover
			  placement="right"
			  width="400"
			  trigger="click">
			 <el-card class="box-card">
			 <div slot="header" class="clearfix">
				<span style="font-size:18px;color:#222;">广告组列表</span>
				<el-button style="float: right; padding: 3px 0" @click="createCampaign" type="text">+创建广告组</el-button>			
			  </div>
			  <div v-for="item in CampaignList" :key="item.id" class="text item" :title="item.name">
				{{item.name}}
			  </div>
			</el-card>
			  <div class="nav-item" slot="reference"><i style="font-size:18px !important;" class="el-icon-s-claim"></i></div>    
			</el-popover>
        </el-tooltip>       
		 <div @click="drawer = true" class="nav-item"><i style="font-size:18px !important;" class="fa fa-cubes"></i></div>
		 <el-tooltip class="item" effect="dark" content="广告自动规则设置" placement="right">
		  <div class="nav-item"  @click.stop="OpenRule"><i style="font-size:18px !important;" class="el-icon-files"></i></div>
		 </el-tooltip>
	  </div>
	</el-aside>
	<el-main style="padding:5px 5px 0px 10px;margin-left:60px;">
	<section style="padding:5px 3px;">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:10px;">
		  <el-breadcrumb-item><a>当前位置</a></el-breadcrumb-item>
		  <el-breadcrumb-item>Toutiao</el-breadcrumb-item>
		  <el-breadcrumb-item>{{advertiser_id}}</el-breadcrumb-item>
		</el-breadcrumb>	
		<div class="hellowd_ads_content">
			<el-form :inline="true">				
				<el-form-item>
					  <el-select size="small" style="width:120px;"clearable v-model="byfield" placeholder="选择筛选">
						<el-option label="广告组" value="campaign"></el-option>
						<el-option label="计划" value="ads"></el-option>
						<el-option label="创意" value="creative"></el-option>
					  </el-select>
					  <el-input size="small" style="width:250px;" clearable v-model="title" placeholder="搜索广告名称,关键词，广告ID"></el-input>
				</el-form-item>				
                <el-form-item>
					<el-select v-model="ad_status" placeholder="广告状态" size="small">
						<el-option label="所有广告" value="all"></el-option>
						<el-option label="投放中" value="enable"></el-option>
						<el-option label="已暂停" value="disable"></el-option>
					  </el-select>
				</el-form-item>
                <el-form-item>
					<el-button  size="small" @click="search" type="primary" plain><i  class="el-icon-search"></i> 查询</el-button>
				</el-form-item>				
                <el-form-item style="float:right;">				   
					<label style="color:#409eff;font-size:12px;">{{main.name}} <i @click="openAccountDrawer" class="fa fa-pencil" aria-hidden="true"></i></label>					
				</el-form-item>					
			</el-form>
			<el-drawer
			  title="选择渠道"
			  size="15%"
			  style="top:60px;"
			  :modal="modal"
			  custom-class="channel_select"
			  :visible.sync="drawer"
			  direction="ltr">
			   <el-row>
			     <el-col :span="24">
			     <div style="padding-right:20%;">
				     <ul style="display:block;">
					   <li><a title="Toutiao"><img src="../../assets/toutiao.png" /></a></li>
					   <li><a title="Facebook"><img src="../../assets/facebook.png" /></a></li>
					   <li><a title="Adwords"><img src="../../assets/adwords.png" /></a></li>
					   <li><a class="other_channel" title="更多其他渠道">更多其他渠道 >> </a></li>
					 </ul>
				 </div>
				</el-col>
			   </el-row>
			</el-drawer>
			<el-drawer
			  title="我管理的账户"
			  size="25%"
			  style="top:60px;"
			  :modal="modal1"
			  custom-class="account_select"
			  :visible.sync="AccountDrawer"
			  direction="rtl">
			   <el-row style="position:relative;height:100%;">
			     <el-col :span="24">
			     <div style="position:absolute;left:0;top:0;right:0;bottom:0;overflow-y:auto;padding-right:15%;overflow-x:hidden;" v-loading="AccountLoading">
				     <ul>
					   <li @click="$router.push(`/toutiao/${item.advertiser_id}`)" v-for="item in AccountList"><a>{{item.name}}</a><div style="color:#666;">{{item.advertiser_id}}</div></li>
					 </ul>
				 </div>
				</el-col>
			   </el-row>
			</el-drawer>
		<el-row  style="margin-bottom:10px;">
		  <el-col :span="24">
		   <div class="promotion-header ad-d-flex ad-d-flex-between">
				<div class="ad-d-flex">
				   <div class="ad-d-flex ad-m-r-lg">
					  <span class="promotion-header-title"><i style="font-size:7px;color:red;" class="fa fa-circle"></i> 今日消耗(元)</span>
					  <span class="promotion-header-money bui-num">{{main.cost}}</span>
				   </div>
				   <div class="ad-d-flex ad-m-r-lg">				  
				    <span class="promotion-header-title attr_other"><i style="font-size:7px;color:#4dd599;" class="fa fa-circle"></i> 展示</span>
				    <span class="">{{main.show}}</span>
				   </div>
				   <div class="ad-d-flex ad-m-r-lg">				  
				    <span class="promotion-header-title attr_other"><i style="font-size:7px;color:#537ec5;" class="fa fa-circle"></i> 点击</span>
				    <span class="">{{main.click}}</span>
				   </div>
				   <div class="ad-d-flex ad-m-r-lg">				  
				    <span class="promotion-header-title attr_other"><i style="font-size:7px;color:#e3b04b;" class="fa fa-circle"></i> 安装</span>
				    <span class="">{{main.convert}}</span>
				   </div>
				   <div class="ad-d-flex ad-m-r-lg">				  
				    <span class="promotion-header-title attr_other"><i style="font-size:7px;color:#cd4dcc;" class="fa fa-circle"></i> CPI</span>
				    <span class="promotion-header-money bui-num">{{main.cpi}}</span>
				   </div>
				   <div class="ad-d-flex ad-m-r-lg">
					   <span class="promotion-header-title attr_other">账户日预算</span>
					   <span class="promotion-header-money ad-m-r-xs bui-num">{{main.budget}}
                      <el-popover
						  placement="right"
						  width="400"
						  v-model="visible">
						  <el-form ref="budgetForm" :model="budgetForm" label-width="80px">
							   <el-form-item label="预算类型">
							     <el-radio-group v-model="budgetForm.budget_mode">
									<el-radio label="BUDGET_MODE_DAY">日预算</el-radio>
									<el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
								  </el-radio-group>
								</el-form-item>
								<el-form-item v-if="budgetForm.budget_mode=='BUDGET_MODE_DAY'" label="日预算">
								  <el-input size="mini" style="width:150px;" v-model="budgetForm.budget">
								   <template slot="append">元</template>
								  </el-input>
								</el-form-item>
							</el-form>
						  <div style="text-align: right; margin: 10px">
							<el-button size="mini" type="text" @click="visible = false">取消</el-button>
							<el-button type="primary" size="mini" v-loading="budgetLoading" @click="updateBudget">确定</el-button>
						  </div>
						  <i slot="reference" class="fa fa-pencil"></i>
					  </el-popover>					   
					   </span>
					</div>
					<div class="ad-spliter"></div>
					<div class="ad-d-flex">
					  <span class="promotion-header-title">
					  <el-tooltip class="item" effect="light" content="账户余额说明:账号可用余额" placement="bottom">
						<i style="color:#ccc;" class="el-icon-info"></i>
					  </el-tooltip> 账户余额</span>
					  <span class="promotion-header-money bui-num">{{main.valid_balance}}</span>
				   </div>
				</div>
				
				<div class="ad-d-flex">
				  <el-date-picker  style="width:220px;" @change="handleDate" value-format="yyyy-MM-dd" size="small" v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				</div>
			</div>
			</el-col>         
		</el-row>
		<!--列表-->
		<el-row>
		<el-tabs v-model="activeName"  @tab-click="handleClick" type="border-card">
		  <el-tab-pane name="CampaignPanel">
			<span slot="label" style=""><i class="el-icon-s-claim"></i> 广告组</span>
			<CampaignPanel ref="Campaign" @updatePannel="updatePannel"  @updateCampaign="getCampaignList" :PannelName.sync="activeName"></CampaignPanel>
		  </el-tab-pane>
		  <el-tab-pane name="AdsPanel">
		   <span slot="label" style=""><i class="el-icon-date"></i> 广告计划</span>
		   <AdsPanel ref="Ads" @updatePannel="updatePannel" :campaign_obj.sync="campaign_obj" @updateData="updateData" @openDrawer="openDrawer" :PannelName.sync="activeName"></AdsPanel>
		  </el-tab-pane>
		  <el-tab-pane name="CreativePanel">
		   <span slot="label" style=""><i class="el-icon-box"></i> 广告创意</span>
		   <CreativePanel ref="Creative" @updateData="updateData" :ad_obj.sync="ad_obj" :PannelName.sync="activeName"></CreativePanel>
		  </el-tab-pane>
		</el-tabs>
		</el-row>		
		</div>
	</section>
	<!--创建广告-->
	 <CreatePanel ref="createdAdsDrawer" :CampaignList.sync="CampaignList"></CreatePanel>
	<!--自动规则-->
	<AutomateRules ref="rule"></AutomateRules>
  </el-main>
</el-container>
</template>

<script>
	import CampaignPanel from './model/campaign.vue'
	import AdsPanel from './model/ads.vue'
	import CreativePanel from './model/creative.vue'
	import CreatePanel from './model/model/drawer.vue'
	import AutomateRules from './model/automate_rules.vue'
	
	import { getCampaignListIndex,getMainInfo,getAccountList,updateAdvertiserBudget,getProductListData } from '../../api/api';
	export default {
		components: {CampaignPanel,AdsPanel,CreativePanel,CreatePanel,AutomateRules},
		data() {
			return {
				title: '',
				drawer: false,
				timer: '',
				AccountDrawer:false,
				advertiser_id:'',
				AccountLoading:false,
				productvisible:false,
				budgetLoading:false,
				CampaignList:[],
				productList:[],
				AccountList:[],
				visible:false,
				ad_obj:{},
				campaign_obj:{},
				budgetForm:{
				 budget:0
				},
                modal:'',
                modal1:'',
				date:[],
				main:{
				  name:"",
				},
				activeName:'CampaignPanel',
				product_keyword:'',
				ad_status:'all',
				byfield:''
			}
		},
		watch: {
			'$route' (to, from) {
			   this.advertiser_id =  this.$route.params.advertiser_id;
			   this.$store.commit('UpdateAdvertiserId',this.advertiser_id)
			   this.AccountDrawer = false
			   switch( this.activeName )
			   {
			     case 'CampaignPanel':
				   this.$refs['Campaign'].getCampaign()
				   break;
				 case 'AdsPanel':
				   this.$refs['Ads'].getAds()
				   break;
				 case 'CreativePanel':
				   this.$refs['Creative'].getCreative()
				   break;
			   }			   
               this.getCampaignList()
			   this.getMain()
			},
			filtering:{
			   handler(val, oldVal){
                 this.$store.commit('UpdateFiltering',val)				 
				},
			   deep:true
			}
		},
		computed:{
	     userid(){
		   return this.$store.getters.getUserId
		 },
		 filtering(){
		   return {
		     title:this.title,
			 byfield:this.byfield,
			 ad_status:this.ad_status,
			 date:this.date		 
		   }
		 }
	    },
		created(){
          this.advertiser_id =  this.$route.params.advertiser_id;		  
		  this.$store.commit('UpdateAdvertiserId',this.advertiser_id)
		},
		methods: {
			openDrawer(){
			  this.AdModalDrawer = false
			  this.AdModalDrawer = true
			  this.$refs.createdAdsDrawer.mainDrawer()
			},
			getProduct(){            
				let params ={
					userid:this.userid
				}
				getProductListData(params).then((res) => {
					this.productList = res.data.list;	
				});			
		    },
			handleDate(){
			  this.getMain()
			  this.search()
			},
			search(){
			  switch( this.activeName )
			   {
			     case 'CampaignPanel':
				   this.$refs['Campaign'].getCampaign()
				   break;
				 case 'AdsPanel':
				   this.$refs['Ads'].getAds()
				   break;
				 case 'CreativePanel':
				   this.$refs['Creative'].getCreative()
				   break;
			   }
			},
			updateData(){
			 this.ad_obj ={}
			 this.campaign_obj ={}
			},
			OpenRule(){
			 //this.$refs.rule.openModel()
			},
			OpenCreateRule(){
			 this.$refs.createrule.openModel()
			},
			updatePannel(params){
			  this.activeName =params.type
			  if( this.activeName=="AdsPanel" )
			  {
			    this.campaign_obj = params.campaign_obj
			  }else if( this.activeName=="CreativePanel" )
			  {
			   this.ad_obj = params.ad_obj
			  }			  
			},
            handleClick(tab, event){
			 this.AdModalDrawer = false
			},
            createCampaign(){
			   this.$refs['Campaign']. CreateCampaign()
			},
            openAccountDrawer(){
			  if(  this.AccountList.length<1 )
			  {
			     let params ={
				    userid:this.userid,
					channel:1
				 }
				 this.AccountLoading = true
				 getAccountList(params).then((res) => {
					 this.AccountLoading = false
					 this.AccountList = res.data;
				});
			  }
			  this.AccountDrawer = true
			},			
			getMain(){
			  let params ={
			     advertiser_id:this.advertiser_id,
                 type:1,
                 start_date:this.date[0]?this.date[0]:'',
				 end_date:this.date[1]?this.date[1]:'',
			  }
			  getMainInfo(params).then((res) => {
					 this.main = res.data
					 this.date = res.data.date
				});
			},
			updateBudget(){
			 this.budgetForm.advertiser_id = this.advertiser_id
			 this.budgetLoading = true
			 updateAdvertiserBudget(this.budgetForm).then((res) => {
					this.budgetLoading = false
					this.visible =false
					this.getMain() 
				});
			},
			getCampaignList(){
			  let params ={
			     advertiser_id:this.advertiser_id,
                 type:1,				 
			  }
			  getCampaignListIndex(params).then((res) => {
					 this.CampaignList = res.data.list;
				});
			}
		},
		mounted() {	
            this.$refs['Campaign'].getCampaign()
            this.getCampaignList()
			this.getProduct()
			this.getMain()
            this.timer = setInterval(this.getMain,12000)
		},
		beforeDestroy() {
		  clearInterval(this.timer)
	  }
	}

</script>
<style  lang="scss">
 @import './style/index.scss'
</style>
<style lang="scss">
 .attr_other{margin-right:4px !important;}
 .product_list img{
	   width:40px;
	   height:35px;
	   border-radius:10px;
	   vertical-align:middle;
	   margin-right:5px;
}
</style>


// WEBPACK FOOTER //
// index.vue?bc2d5a50